import React from 'react'
import {Icon} from '@chakra-ui/react'

const MinusIcon = (props) => {
    return (
        <Icon
            as="svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 11 11"
            fill="none"
            data-testid="minus-icon"
            {...props}
            aria-hidden="true"
        >
            <path
                d="M0.75 4.66699H10.083C10.4972 4.66699 10.833 5.00278 10.833 5.41699C10.833 5.83121 10.4972 6.16699 10.083 6.16699H0.75C0.335955 6.16679 0 5.83108 0 5.41699C0 5.0029 0.335955 4.66719 0.75 4.66699Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default MinusIcon
